module.exports = __webpack_public_path__ + "img/red-diamond.56640e18.png";